<template>
  <div class="goods">
    <van-nav-bar
      :title="data.prod_name"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"/>

    <van-swipe class="goods-swipe" :autoplay="3000">
      <van-swipe-item v-for="item in data.images" :key="item.id">
        <img :src="item.img_url" >
      </van-swipe-item>
    </van-swipe>

    <van-cell-group>
      <van-cell>
        <div class="goods-title">{{ data.prod_name }}</div>
        <div class="goods-price">{{ '¥' + (curversion.price?curversion.price:0).toFixed(2) }}</div>
      </van-cell>
      <van-cell class="goods-express" :title="data.brand_name"/>
    </van-cell-group>

    <van-cell-group class="goods-cell-group">
      <van-cell title="版本" :value="curversion.name" is-link @click="showPickVersion=true"/>
      <van-cell title="规格" :value="data.spc" />
      <van-cell title="条码" :value="data.barcode" />
    </van-cell-group>

    <van-collapse v-model="actionContent">
      <van-collapse-item title="使用车型" name="1">
        <van-list>
          <van-cell
            v-for="item in data.adapters" 
            :key="item.i"
            :title="item.n"/>
        </van-list>
      </van-collapse-item>
      <van-collapse-item title="用途" name="2">
          <van-list>
            <van-cell
              v-for="item in data.purposes" 
              :key="item.id"
              :title="item.name"/>
        </van-list>
      </van-collapse-item>
      <van-collapse-item title="属性" name="3">
        <van-list>
          <van-cell
            v-for="item in data.attributes" 
            :key="item.i"
            :title="item.property_name"
            :value="item.value_name"/>
        </van-list>
      </van-collapse-item>
    </van-collapse>

    <van-panel title="说明" :desc="data.rem"/>

    <van-goods-action>
      <!-- <van-goods-action-icon icon="chat-o" @click="sorry">
        客服
      </van-goods-action-icon> -->
      <van-goods-action-icon icon="cart-o" @click="toCart" :info="cartNum">
        购物车
      </van-goods-action-icon>
      <van-goods-action-button type="warning" @click="addCart">
        加入购物车
      </van-goods-action-button>
      <van-goods-action-button type="danger" @click="buyNow">
        立即购买
      </van-goods-action-button>
    </van-goods-action>

    <van-action-sheet
      v-model="showPickVersion"
      :actions="data.versionprices"
      cancel-text="取消"
      @cancel="showPickVersion=false"
      @select="pickVersion" />
  </div>
</template>

<script>
import { ProductApi, CartApi, FavProductApi } from '@/api/market'
import {
  Tag,
  Col,
  Icon,
  Cell,
  CellGroup,
  Swipe,
  Collapse,
  CollapseItem,
  List,
  Panel,
  NavBar,
  SwipeItem,
  ActionSheet,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Toast
} from 'vant';

export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [List.name]: List,
    [Panel.name]: Panel,
    [SwipeItem.name]: SwipeItem,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton
  },

  data() {
    return {
      data: {
        prod_name: '',
        brand_name: '',
        spc: '',
        cls_name: '',
        cls1_name: '',
        barcode: '',
        price: '',
        rem: '',
        images: [],
        versionprices: [],
        purposes: [],
        attributes: [],
        adapters: [],
        prod1_id: null,
        cls: null,
        cls1: null,
        qty: 1
      },
      actionContent: ['0'], // 显示规格等
      id: this.$route.params.id,
      showPickVersion: false,
      cartNum: 0, // 购物车数量
      curversion: {
        id: null,
        name: '',
        price: null,
        cost: null,
        img: null,
        url: null
      }, // 当前版本
      addSuccess: false,
      lunbo: []
    };
  },
  mounted() {
    this.getData()
    this.getCart()
  },
  methods: {
    getData() {
      var that = this
      this.axios.get(ProductApi + that.id + '/').then(function (ret) {
        that.data.prod_name = ret.details.car_products_name
        that.data.brand_name = ret.details.brand_name
        that.data.spc = ret.details.car_products_spc
        that.data.cls_name = ret.details.cls_name
        that.data.cls1_name = ret.details.cls1_name
        that.data.cls = ret.details.cls
        that.data.prod1_id = ret.details.prod1_id
        that.data.cls1 = ret.details.cls1
        that.data.barcode = ret.details.barcode
        that.data.price = ret.details.price
        that.data.rem = ret.details.rem
        that.data.images = ret.details.imagetext_values
        that.data.versionprices = ret.details.versionprice
        that.data.purposes = ret.details.purpose_values
        that.data.attributes = ret.details.attribute
        that.data.adapters = ret.details.adapter_values

        if (that.data.versionprices.length > 0) {
          that.curversion = that.data.versionprices[0]
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    addFav() {
      var that = this
      const data = {
        car_products: this.curversion.id
      }
      that.axios.post(FavProductApi, data).then((ret) => {
        console.log(ret)
        if (ret.flag) {
          Toast('收藏完毕')
        } else {
          Toast('失败')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    addCart() {
      var that = this
      const data = {
        car_products: this.curversion.id,
        qty: 1,
        price: this.curversion.price
      }
      that.axios.post(CartApi, data).then(function (ret) {
        if (ret.flag) {
          Toast('加入购物车')
          that.$router.push('/home')
        }
      }).catch(function (error) {
        // Toast(error)
        console.log(error)
      })
    },
    getCart() {
      var that = this
      that.axios.get(CartApi).then(function (ret) {
        console.log(ret)
        console.log(ret.count)
        that.cartNum = ret.count
      }).catch(function (error) {
        console.log(error)
      })
    },
    pickVersion(item) {
      console.log(item)
      this.curversion = item
      this.showPickVersion = false
    },
    toCart() {
      this.$router.push('/cart');
    },
    buyNow() {
      let items = []
      items.push({
        version_id: this.curversion.id,
        version_name: this.curversion.name,
        prd1_id: this.data.prod1_id,
        prd_name: this.data.prod_name,
        cls: this.data.cls,
        cls1: this.data.cls1,
        qty: this.data.qty,
        price: this.curversion.price,
        img: this.curversion.url
      })
      const data = {
        source: 'order',
        data: items
      }
      this.$router.push({
        name: 'order',
        query: JSON.stringify(data)
      })
    },
    // sorry() {
    //   Toast('暂无后续逻辑~');
    // },
    onClickLeft() {
      // this.$router.back(-1)
      // this.$router.go(-1)
      this.$router.push('/home')
    }
  }
};
</script>

<style lang="less">
.goods {
  padding-bottom: 50px;

  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
</style>
